<template>
    <el-dialog
        v-loading='loading'
        class="common-dialog"
        :visible.sync="visible"
        :show-close='false'
        :close-on-click-modal="false"
        width="680px">
        <div class="dialog-content">
            <el-form
                ref="modifyForm"
                :model="searchForm">
                <div class="con-filed">
                    <div class="con-title">基本信息</div>
                    <div class="info">
                        <el-form-item
                            label="姓名：">
                            <div class="el-input">{{data.name}}</div>
                        </el-form-item>
                        <el-form-item
                            label="手机号：">
                            <div class="el-input">{{data.entryPhone}}</div>
                        </el-form-item>
                        <el-form-item
                            label="邮箱：">
                            <div class="el-input">{{data.entryEmail}}</div>
                        </el-form-item>
                        <el-form-item
                            label="预计入职日期：">
                            <div class="el-input">{{data.entryDt}}</div>
                        </el-form-item>
                    </div>
                </div>
                <div class="con-filed">
                    <div class="con-title">修改后基本信息</div>
                    <div class="info">
                        <el-form-item
                            :rules="rules.phone"
                            prop="entryPhone"
                            label="手机号：">
                            <el-input
                                v-model="searchForm.entryPhone"
                                placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <br/>
                        <el-form-item
                            :rules="rules.email"
                            prop="entryEmail"
                            label="邮箱：">
                            <el-input
                                v-model="searchForm.entryEmail"
                                placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item
                            :rules="[{ required: true, message: '确认入职日期不能为空', trigger: 'blur' }]"
                            prop="entryDt"
                            label="确认入职日期：">
                            <el-date-picker
                                v-model="searchForm.entryDt"
                                type="date"
                                @change="isGoDay"
                                placeholder="选择确认入职日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer txt-center">
            <el-button
                size="small"
                @click="cancel">取消</el-button>
            <el-button
                size="small"
                @click="confirm"
                type="primary">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getSchedule, modifyInfo } from '@/network'

export default {
    name: 'modifyInfo',
    props: ['visible', 'data'],
    data() {
        const validatephone = (rule, value, callback) => {
			const reg = /^1\d{10}$/
			if (value === '') {
				callback(new Error('手机号码不能为空'))
			} else if (!reg.test(value)) {
				callback(new Error('请输入正确输入手机号码'))
			} else {
				callback()
			}
		}
		const validateEmail = (rule, value, callback) => {
			const reg = new RegExp('^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$');
			if (value === '') {
				callback(new Error('个人邮箱不能为空'));
			} else if (!reg.test(value)) {
				callback(new Error('请输入正确的个人邮箱'));
			} else {
				callback();
			}
		}
        return {
            searchForm: {},
            loading: false,
            rules: {
				phone: [
					{ required: true, validator: validatephone, trigger: 'blur' },
				],
				email: [
					{ required: true, validator: validateEmail, trigger: 'blur' },
				],
			},
        }
    },
    methods: {
        confirm() {
            this.$refs.modifyForm.validate((valid) => {
                if (valid) {
                    this.save()
                } else {
                    this.$message.warning('填写信息有误，请检查')
                }
            })
        },
        async save() {
            this.loading = true
            let res = await modifyInfo(this.searchForm).catch(() => {})
            this.loading = false
            if (!res) return
            this.$parent.dialogVisible = false
            this.$parent.updateData(this.searchForm)
            this.$message.success('修改成功')
            this.$refs.modifyForm.resetFields()
        },
        cancel() {
            this.$refs.modifyForm.resetFields()
            this.$parent.dialogVisible = false
        },
        // 判断是否工作日
		isGoDay(dateVal){
			if(dateVal && dateVal !== ''){
				return getSchedule(dateVal).then((res)=>{
					let data = res.data
					if(data.code === 'S00000'){
						if(data.data.status === 'Y'){
							this.$message.warning(dateVal + '是非工作日，请选择工作日')
							this.searchForm.entryDt = ''
						}
					} else {
						this.$message.error(data.message)
					}
				})
			}
		},
    },
    watch: {
        data: {
            handler(v) {
                this.searchForm = {
                    bizId: v.bizId,
                    entryPhone: v.entryPhone,
                    entryEmail: v.entryEmail,
                    entryDt: v.entryDt,
                }
            },
            deep: true,
        },
    },
}
</script>

<style lang="scss">
.dialog-content{
    .con-filed:first-child{
        border-bottom: 1px solid #ccc;
    }
    .con-filed:last-child{
        margin-top: 20px;
    }
    .el-form-item__content .el-date-editor.el-input{
        width: 172px;
    }
}
</style>